<form [formGroup]="vehicleOfflineBind">
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <div class="flex">
      @if (classicOnlyAutoPolicyOrCompOnlyAdv) {
        <div class="icon margin-right-8">
          <i class="icon-amfam-alert-triangle-fill-1 font-size-2 warning-icon-color"> </i>
        </div>
      }
      <h2
        dsContent
        class="bold-header pad-bottom-20"
        data-cy="vehicleOfflineBindSubheading"
        [contentPath]="headerContentPath"
      ></h2>
    </div>
    <div>
      @if (classicOnlyAutoPolicyOrCompOnlyAdv) {
        <p dsContent data-cy="vehicleOfflineBindHelpText" [contentPath]="bodyContentPath"></p>
      }
    </div>
    <div class="add-vehicle-title">
      <div class="row vehicle">
        <div class="flex self-center pad-10">
          <div class="self-center pad-right-30" aria-hidden="true">
            <span class="icon-auto"></span>
          </div>
          <div class="self-center">
            <div class="risk-info">
              <div class="caption" dsContent [contentPath]="'policy.newVehicleCaption'"></div>
              <div class="heading" data-cy="vehicleOfflineBindRiskDescription">
                {{ vehicleRiskDescription$ | async }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (!classicOnlyAutoPolicyOrCompOnlyAdv) {
      <div>
        <p dsContent data-cy="vehicleOfflineBindHelpText" [contentPath]="bodyContentPath"></p>
      </div>
    }
  </div>
  <ds-exit-flow-modal
    [exitFlowModalId]="exitFlowModalId"
    (exit)="navigateToOverview()"
    (cancelModal)="stayFromExitModal()"
    (notifyAgent)="sendToAgent()"
  ></ds-exit-flow-modal>
  <div class="row margin-top-50 column twelve lg-push-two md-eight md-push-two">
    <hr />
    <call-to-action
      [displayBackButton]="true"
      [tertiaryButtonName]="'Cancel'"
      [primaryButtonName]="sendToBtnText"
      [disabled]="vehicleOfflineBind.disabled"
      (primaryEvent)="sendToAgent()"
      (tertiaryEvent)="onCancel()"
      (backEvent)="goBackOneStep()"
    ></call-to-action>
  </div>
</form>
